import {Base} from "@/api/Base"

export class AdvisorCommissionListByIdAdv extends Base {
    path = "advisorCommission/listByIdAdv"
}